module.exports = __webpack_public_path__ + "img/competence_icon_individual.8b04415.svg";